var flag_search = null;

$('.js-search').on('input', function () {

    var q = $(this).val();
    var id = $(this).attr('id');

    if (q.length > 2) {
        flag_search = uniqueId('search');

        $.post(url__api__search, {
            'q': q,
            'flag_search': flag_search
        }, function (data) {
            // console.log(data);

            setTimeout(function () {
                if (data.flag_search == flag_search) {

                    var html = '';

                    html = document.getElementById('template--search-close').innerHTML;

                    for (var i = 0; i < data.products.length; i++) {

                        var productHtml = document.getElementById('template--search-row').innerHTML;

                        var downloadshtml = '';
                        for (var j = 0; j < data.products[i].downloads.length; j++) {
                            var downloadHtml = document.getElementById('template--search-row--download').innerHTML;
                            downloadHtml = downloadHtml.replace('[[DOWNLOAD_URL]]', data.products[i].downloads[j].url);
                            downloadHtml = downloadHtml.replace('[[DOWNLOAD_TITLE]]', data.products[i].downloads[j].name);
                            downloadHtml = downloadHtml.replace('[[DOWNLOAD_ICON]]', data.products[i].downloads[j].icon);
                            // console.log(downloadHtml, data.products[i].downloads[j]);
                            downloadshtml = downloadshtml + downloadHtml;
                        }
                        // console.log(downloadshtml);
                        productHtml = productHtml.replace('[[PRODUCT_ABSTRACT]]', data.products[i].abstract);
                        productHtml = productHtml.replace('[[PRODUCT_TITLE]]', data.products[i].name);
                        productHtml = productHtml.replace('[[PRODUCT_IMAGE]]', data.products[i].image);
                        productHtml = productHtml.replace('[[PRODUCT_URL]]', data.products[i].url);
                        productHtml = productHtml.replace('[[PRODUCT_DOWNLOADS]]', downloadshtml);
                        // console.log(productHtml, data.products[i]);

                        html = html + productHtml;
                    }

                    $('.js-searchSuggestions[data-ref="'+id+'"]').html(html);
                }
            }, 100);
        });
    } else if (q.length == 0) {
        $('.js-searchSuggestions[data-ref="'+id+'"]').html('');

    }
});

function closeSearchSuggestions(e) {
    $(e).parents(".js-searchSuggestions").html('');
    $('.js-search').val('');
}